import React from "react";
import { Link } from "react-scroll";
import Logo from "../elements/Logo";
import { useHistory } from "react-router-dom";

function Header({ light, logoSource, toggleMenu, headerToggler }) {
  const history = useHistory();
  const handleClasses = () => {
    let classes = "desktop-header-1 d-flex align-items-start flex-column";
    if (light & toggleMenu) {
      classes += " light open";
    } else if (toggleMenu) {
      classes += " open";
    } else if (light) {
      classes += " light";
    }
    return classes;
  };
  const handleMobileClasses = () => {
    let classes = "mobile-header-1";
    if (light & toggleMenu) {
      classes += " light open";
    } else if (toggleMenu) {
      classes += " open";
    } else if (light) {
      classes += " light";
    }
    return classes;
  };
  const redirectHome = () => {
    if (window.location.pathname != "/") {
      history.push("/");
    }
    return "section-home";
  };
  const redirectAbout = () => {
    if (window.location.pathname != "/") {
      history.push("/");
    }
    return "section-about";
  };
  const redirectSkills = () => {
    if (window.location.pathname != "/") {
      history.push("/");
    }
    return "section-services";
  };
  const redirectExperience = () => {
    if (window.location.pathname != "/") {
      history.push("/");
    }
    return "section-experiences";
  };
  const redirectProjects = () => {
    if (window.location.pathname != "/") {
      history.push("/");
    }
    return "section-blogs";
  };
  const redirectContact = () => {
    if (window.location.pathname != "/") {
      history.push("/");
    }
    return "section-contact";
  };
  return (
    <>
      <header className={handleMobileClasses()}>
        <div className="container">
          <div className="menu-icon d-inline-flex mr-4">
            <button onClick={headerToggler}>
              <span></span>
            </button>
          </div>
        </div>
      </header>
      <header className={handleClasses()}>
        {/* <Logo logoSource={logoSource} /> */}
        <nav>
          <ul className="vertical-menu scrollspy">
            <li>
              <Link
                activeClass="active"
                to="section-home"
                onClick={redirectHome}
                spy={true}
                smooth={true}
                duration={100}
              >
                <i className="icon-home"></i>Home
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-about"
                onClick={redirectAbout}
                spy={true}
                smooth={true}
                duration={100}
              >
                <i className="icon-user-following"></i>About
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-services"
                onClick={redirectSkills}
                spy={true}
                smooth={true}
                duration={100}
              >
                <i className="icon-briefcase"></i>Skills
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-experiences"
                onClick={redirectExperience}
                spy={true}
                smooth={true}
                duration={100}
              >
                <i className="icon-graduation"></i>Experience
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-blogs"
                onClick={redirectProjects}
                spy={true}
                smooth={true}
                duration={100}
              >
                <i className="icon-note"></i>Projects
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-contact"
                onClick={redirectContact}
                spy={true}
                smooth={true}
                duration={100}
              >
                <i className="icon-bubbles"></i>Contact
              </Link>
            </li>
          </ul>
        </nav>

        <div className="footer">
          <span className="copyright">Powered by React.JS</span>
        </div>
      </header>
    </>
  );
}

export default Header;
